import { MeterType, EnergyMetersSubTypes } from '@/types/meters'
import { ExtendedSeries, SeriesName } from '@/types/meters'

export interface SeriesFilter {
    type?: MeterType
    subType?: EnergyMetersSubTypes
    series: SeriesName[]
}

type Filterable = Pick<ExtendedSeries, 'type' | 'subType' | 'name'>

export function filterSeries<T extends Filterable>(series: T[], filters: SeriesFilter): T[] {
    return series.filter((s) => {
        if (filters.type && s.type !== filters.type) {
            return false
        }

        if (filters.subType && s.subType !== filters.subType) {
            return false
        }

        return filters.series.includes(s.name as SeriesName)
    })
}
